// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCurrency-Error_cls1__o2hvq","cls2":"VeloCurrency-Error_cls2__9gXG1 VeloCurrency-Error_cls1__o2hvq"};